var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mockData as documentEventsData } from '@web/lib/demo/data/documentEvents';
import { filterData, getOrgUnits, getUserOrgUnits, getUsers } from '@web/lib/demo/utils';
import { activityGroupByOrgUnitOrUser } from '@workalizer/shared/utils';
export var documentActivityEventsAnalytic = function (input) {
    var users = getUsers({
        orgUnitId: input.orgUnitId,
        userId: input.userId
    });
    var orgUnits = getOrgUnits({
        orgUnitId: input.orgUnitId
    });
    var documentEvents = filterData(documentEventsData, [
        {
            key: 'date',
            value: input.dateFrom,
            operator: 'gt'
        },
        {
            key: 'date',
            value: input.dateTo,
            operator: 'lt'
        },
        {
            key: 'userId',
            value: users.map(function (user) { return user.id; }),
            operator: 'in'
        }
    ])
        .map(function (item) { return (__assign(__assign({}, item), { date: new Date(item.date), createdAt: new Date(item.createdAt), updatedAt: new Date(item.updatedAt) })); })
        .map(function (event) { return ({
        date: new Date(event.date),
        userId: event.userId,
        _count: { id: 1 }
    }); });
    var userOrgUnits = getUserOrgUnits();
    var dataOrgUnits = activityGroupByOrgUnitOrUser(new Date(input.dateFrom), new Date(input.dateTo), input.orgUnitId || input.userId ? 'user' : 'orgUnit', orgUnits, users, userOrgUnits, documentEvents, input.groupBy);
    return dataOrgUnits;
};
